<template>
  <div class="wrapper-menu wh100p df">
    <!-- 对话框 -->
    <section class="section-dialog h100p" v-if="sceneId_here">

      <!-- 对话框头部 餐桌堂食 -->
      <div class="dialog-head _themebackground w100p df-c-ct" v-if="type==='normal'">
        <div class="f-m f-white">{{orderData.code+(orderData.showNo>1?('-'+orderData.showNo):'')}}</div>
        <div class="select-box" v-if="shop_x.sceneAsMenu">
          <el-select :popper-append-to-body="false" style="width:100px;" v-model="selectSceneId" @change="sceneChange">
            <el-option :label="x.name" :value="x.id" v-for="(x,i) in sceneList" :key="i" />
          </el-select>
        </div>
      </div>
      <!-- 对话框头部 餐桌外卖 -->
      <div class="dialog-head _themebackground w100p df-c-ct" v-else-if="type==='takeaways'">
        <div class="f-m f-white">{{$t('menu.takeaway')}}</div>
      </div>
      <!-- 对话框头部 自定义外卖 -->
      <div class="dialog-head _themebackground w100p df-c-ct" v-else-if="type==='custom'">
        <div class="f-m f-white" style="text-align:center;padding:0 40px;">{{customTakeaway['name'+_lang]}}</div>
      </div>
      <!-- 对话框头部 快餐 -->
      <div class="dialog-head w100p df-c-ct" v-else-if="type==='fastfood'">
        <div class="dialog-head-btn _themecolor f-m h100p f1" :class="{'_themebackground _cf':typeIndex===1}" @click="typeIndexChange(1)" v-if="isShowTangshiBtn">{{$t('menu.tangshi')}}</div>
        <div class="dialog-head-btn _themecolor f-m h100p f1" :class="{'_themebackground _cf':typeIndex===2}" @click="typeIndexChange(2)" v-if="isShowTakeawayBtn">{{$t('menu.takeaway')}}</div>
      </div>
      <!-- 对话框头部 编辑 -->
      <div class="dialog-head _themebackground w100p df-c-ct" v-else-if="['edit','editcustom'].includes(type)">
        <div class="f-m f-white">{{$t('order.orderNo')}}：{{orderData.orderNo}}</div>
      </div>

      <!-- 对话框内容 -->
      <div class="dialog-con w100p df-l-fs" :class="type+step">
        <!-- 外卖 表单 -->
        <template v-if="['takeaways','fastfood','custom'].includes(type)&&step==='1'">
          <!-- 信息 -->
          <div class="dialog-input _borderbottom df-l-sa">
            <div class="dialog-input-item df-c-sb" v-for="(x,i) in takeawayInfo" :key="i">
              <div class="dialog-input-label f-dark">{{$t('menu.'+x.key)}}</div>
              <input class="dialog-input-input _inputborder f-xxs f-gray" v-model="takeawayForm[x.key]" @focus="onFocus_forScan" @blur="onBlur_forScan" />
            </div>
            <div class="dialog-input-item df-c-sb">
              <div class="dialog-input-label f-dark">{{$t('menu.pickupTime')}}</div>
              <div class="dialog-input-input _inputborder f-xxs f-gray" @click="openDialogTime">{{takeawayForm.time}}</div>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="dialog-btn themebtn" @click="submitTel">{{$t('common.comfirm')}}</div>
        </template>
        <!-- 购物车 外卖+堂食 -->
        <template v-else-if="(['takeaways','fastfood','custom'].includes(type)&&step==='2')||['normal','edit','editcustom'].includes(type)">
          <!-- 信息 -->
          <section class="dialog-con-top _borderbottom df-l-sa" v-if="
            (['takeaways','fastfood','custom'].includes(type)&&step==='2')
            ||(['edit','editcustom'].includes(type)&&[2,4].includes(orderData.orderType))
          ">
            <div class="dialog-input-item df-c-sb" v-for="(x,i) in takeawayInfo" :key="i">
              <div class="dialog-input-label f-dark">{{$t('menu.'+x.key)}}</div>
              <input
                class="dialog-input-input _inputborder f-xxs f-gray"
                v-model="takeawayForm[x.key]"
                v-show="x.editable"
                @focus="onFocus_forScan"
                @blur="addOrderInfo(x)" />
              <div class="df-c-ct" @click="x.editable=true" v-show="!x.editable">
                <div class="f-gray f-xxs">{{takeawayForm[x.key]}}</div>
                <img src="@/assets/icons/edit.png" style="width:14px;height:14px;margin-left:8px;">
              </div>
            </div>
            <div class="dialog-input-item df-c-sb">
              <div class="dialog-input-label f-dark">{{$t('menu.pickupTime')}}</div>
              <!-- <div class="dialog-input-input _inputborder f-xxs f-gray" @click="openDialogTime">{{takeawayForm.time}}</div> -->
              <div class="df-c-ct" @click="openDialogTime">
                <div class="f-gray f-xxs">{{takeawayForm.time}}</div>
                <img src="@/assets/icons/edit.png" style="width:14px;height:14px;margin-left:8px;">
              </div>
            </div>
          </section>
          <!-- 商品 -->
          <section class="scrolly f1">
            <div v-for="(x,i) in cartItems" :key="x.id" class="list-fade-item _borderbottom df-l-fs" :ref="'item'+i">
              <div class="item" :class="{'item-ban':hasSendCookIds.includes(x.id)}">
                <!-- 显示部分 -->
                <div class="item-show df-sb" @click="tapCartItem(x)">
                  <!-- 勾选框 -->
                  <div class="checkbox" v-if="shopConfig_m.printerDelay">
                    <img
                      :src="hasSendCookIds.includes(x.id)?iconCheckdis:newSendCookIds.includes(x.id)?iconCheckok:iconChecknull"
                      style="width:24px;height:24px;"
                      @click.prevent.stop="checkItemCook(x)">
                  </div>
                  <!-- 商品信息 -->
                  <div class="item-infos sls f1">
                    <div class="item-info sls">{{x['itemName'+_lang]}}</div>
                    <div class="item-info item-info-price-box df-c-sb">
                      <div class="f1 f-xxs">{{x.itemPrice|toprice(2)}}/{{$t('menu.unit')}}</div>
                      <div class="f1 f-xxs" v-if="isShowTimeOfPlaceOrders&&hasSendCookIds.includes(x.id)">
                        <span class="time">{{x['sendToKitchenTimeText'+_lang]}}</span>
                      </div>
                    </div>
                    <CartItemDetail :item="x" />
                  </div>
                  <!-- 折叠按钮 + 计数器 -->
                  <div class="item-counter df-l-sb ai-fe" :class="{'img-to-gray':hasSendCookIds.includes(x.id)}">
                    <div @click.prevent.stop="changeOpenItem(i)">
                      <img class="more-btn" :class="{'rotate180':activeIndex===i}" src="@/assets/icons/arrow1.png">
                    </div>
                    <div class="df-c-ct">
                      <img class="item-btn" :src="iconSubtract1" @click.prevent.stop="tapSubtract(x)" :class="{'img-to-gray':x.count<2}">
                      <div class="item-number">{{x.count|tothousands}}</div>
                      <img class="item-btn" :src="hasSendCookIds.includes(x.id)?iconAdd1dis:iconAdd1" @click.prevent.stop="changeItemCount(x,1)">
                    </div>
                  </div>
                </div>
                <!-- 隐藏部分 -->
                <div class="item-hide"
                  :style="'height:'+(activeIndex===i?76:0)+'px;margin-top:'+(activeIndex===i?6:0)+'px;'">
                  <div class="hang df-c-sb">
                    <div class="df-c-fs" @click="markItemType(x)" v-if="['normal','fastfood'].includes(type)">
                      <img :src="x.takeout?iconCheckok:iconChecknull" style="width:24px;height:24px;margin-right:8px;">
                      <div class="f-xxs">{{$t('menu.takeaway')}}</div>
                    </div>
                    <div v-else></div>
                    <div>
                      <div class="remark-input _inputborder f-xxxs f-gray sls" @click="openDialogOrderRemark('item',x)">{{x|toremark(true)}}</div>
                    </div>
                  </div>
                  <div class="df-fe">
                    <div class="redbtn-xs reminder-btn" @click="reminderItem(x)" v-if="isShowDishReminderEnable&&hasSendCookIds.includes(x.id)">
                      {{$t('common.reminder2')}}</div>
                    <div class="themebtn-xs move-btn" @click="moveTable(x)" v-if="isShowDishMovementEnable&&hasSendCookIds.includes(x.id)">
                      {{$t('home.tableMove')}}</div>
                    <div class="delete-btn" @click="delItem(x)">{{$t('common.delete')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 按钮 -->
          <section class="dialog-con-btm">
            <div class="texts _borderbottom _bordertop">
              <!-- 包装费 -->
              <div class="f-xxxs f-gray df-c-fs" style="margin-bottom:10px;"
                v-if="orderData.takeout">
                <!-- v-if="
                  (['takeaways','fastfood','custom'].includes(type)&&step==='2')
                    ||(['edit','editcustom'].includes(type)&&orderData.orderType===2)
                    ||orderData.packageFee>0
                "> -->
                <div>{{$t('common.packageFee')}}：</div>
                <template v-if="shopConfig_m.packageFeeSelect===3">
                  <img style="width:24px;height:24px;"
                    :src="iconSubtract1"
                    @click.prevent.stop="addOrderPackageFee(-shopConfig_m.packageFeeFloat)"
                    :class="{'img-to-gray':orderData.packageFee===0}">
                  <div style="min-width:24px;text-align:center;padding:0 8px;">{{orderData.packageFee|toprice(2)}}</div>
                  <img style="width:24px;height:24px;"
                    :src="iconAdd1"
                    @click.prevent.stop="addOrderPackageFee(shopConfig_m.packageFeeFloat)">
                </template>
                <template v-else-if="shopConfig_m.packageFeeSelect===2||shopConfig_m.packageFeeSelect===1">
                  <div style="min-width:24px;text-align:center;">{{orderData.packageFee|toprice(2)}}</div>
                </template>
              </div>
              <div class="df-c-sb">
                <!-- 备注 -->
                <div class="f-xxxs f-gray df-c-fs">
                  <div>{{$t('remark.remark')}}：</div>
                  <div class="remark-input _inputborder f-xxxs f-gray sls" @click="openDialogOrderRemark('order')">
                    {{orderData|toremark(true)}}
                  </div>
                </div>
                <div>
                  <img style="width:22px;height:22px;" :src="iconKeyboard" @click="openDialogCusfood" />
                </div>
              </div>
            </div>
            <!-- 服务费 消费税 小计 总计 -->
            <div class="">
              <div class="df-c-sb">
                <div class="texts f-xxs f-gray" v-if="orderData.serviceFee">
                  {{$t('common.serviceFee')}}：{{orderData.serviceFee|toprice(2)}}
                </div>
                <div class="texts f-xxs f-gray" v-if="orderData.takeOutDiscountFee">
                  {{$t({us:'common.discounttakeaway2',hk:'common.discounttakeaway'}[sysEnv_x])}}：-{{orderData.takeOutDiscountFee|toprice(2)}}
                  </div>
                <div v-else></div>
                <div class="texts f-xxs f-gray" v-if="sysEnv_x==='us'">
                  {{$t('common.tax2')}}({{shopConfig_m.consumptionTax}}%)：{{orderData.consumptionTax|toprice(2)}}
                </div>
                <div v-else></div>
              </div>
              <div class="df-c-sb">
                <div class="texts f-xxs f-dark">{{$t('common.price')}}：{{orderData.costOrigin|toprice(2)}}</div>
                <div class="texts">
                  <span class="f-s f-dark">{{$t('common.total')}}：</span>
                  <span class="f-s _redcolor">{{orderData.userCost|toprice(2)}}</span>
                </div>
              </div>
            </div>

            <!-- <div class="dialog-btm df-c-fe" v-if="['custom','editcustom'].includes(type)">
              <div class="btn" :class="{'themebtn-s':cartItems.length,'darkbtn-s':cartItems.length===0}" @click="cartItems.length?calcClick():''">{{$t('common.comfirm')}}</div>
            </div> -->
            
            <div class="dialog-btm" :class="customTakeaway.enablePayType?'df-c-fe':'df-c-sb'" v-if="['custom','editcustom'].includes(type)">
              <template v-if="!customTakeaway.enablePayType">
                <div class="btn whitebtn-s" :style="lang==='en'?'font-size:12px;padding:0;':''" @click="sendCookClick">{{$t('menu.sendKitchen')}}</div>
                <div class="btn whitebtn-s" @click="cartItems.length?printOrderClick():''">{{$t('menu.printOrder')}}</div>
              </template>
              <div class="btn" :class="{'themebtn-s':cartItems.length,'darkbtn-s':cartItems.length===0}" @click="cartItems.length?calcClick():''">{{$t('common.comfirm')}}</div>
            </div>
            
            <div class="dialog-btm df-c-sb" v-else>
              <div class="btn whitebtn-s" :style="lang==='en'?'font-size:12px;padding:0;':''" @click="sendCookClick">{{$t('menu.sendKitchen')}}</div>
              <div class="btn whitebtn-s" @click="cartItems.length?printOrderClick():''">{{$t('menu.printOrder')}}</div>
              <div class="btn" :class="{'themebtn-s':cartItems.length,'darkbtn-s':cartItems.length===0}" @click="cartItems.length?calcClick():''">{{$t('menu.calc')}}</div>
            </div>
          </section>
        </template>
      </div>
    </section>

    <!-- 菜单 -->
    <section class="section-right h100p f1 df-l-fs" v-if="sceneId_here">
      <!-- 導航欄 -->
      <section class="section-navs df-w-fs">
        <div
          v-for="(x,i) in categorys" :key="i"
          class="nav f-m" :class="{'_themecolor active':categoryIndex===i}"
          @click="changeCategory(x,i)">{{x.key?$t('menu.'+x.key):x['name'+_lang]}}
        </div>
      </section>
      <!-- 內容區 -->
      <section class="section-con f1">
        <!-- 搜索 -->
        <!-- <section class="section-search">
          <input class="input" v-model="searchKey" :placeholder="$t('menu.inputItemName')" @focus="onFocus_forScan" @blur="onBlur_forScan" />
          <img src="@/assets/icons/magnifier.png" class="iconmagnifier" @click="searchItem">
        </section> -->
        <!-- 列表 -->
        <section class="section-items df-w-fs">
          <div
            v-for="(x,i) in items" :key="i"
            class="item df-l-c-fs" :class="{'item-noimg':!shopConfig_m.itemImgBEndEnable,'hide':x.saleOut}"
            :data-hide="$t('item.hide')" @click="throttle1000('tapMenuItem',x)">
            <div class="imgsquarebox" style="padding-top:80%" v-if="shopConfig_m.itemImgBEndEnable">
              <el-image :src="(x.imgId||x.itemImgId)|toimg" fit="cover" v-if="x.imgId||x.itemImgId"></el-image>
            </div>
            <div class="name w100p f-xs df-c-ct">
              <span class="slm2">{{x['name'+_lang]||x['itemName'+_lang]}}</span>
            </div>
          </div>
        </section>
      </section>
    </section>

    <!-- 支付 -->
    <DialogPay ref="DialogPay" :showBindCustomerBtn="true" @close="NavToPrePage" @navToClac="navToClacAndOpenDialog" />
    <!-- 二级密码 -->
    <DialogKey ref="DialogKey" />
    <!-- 报错 -->
    <DialogError ref="DialogError" :messages="stockErrorFoods" />
    <!-- 套餐 -->
    <DialogCombo ref="DialogCombo" @submit="dialogComboOrSpecSubmit" />
    <!-- 规格菜 -->
    <DialogSpec ref="DialogSpec" @submit="dialogComboOrSpecSubmit" />
    <!-- 自定义菜 -->
    <DialogCusfood ref="DialogCusfood" @submitDialog="submitDialogCusfood" />
    <!-- 时价菜 -->
    <DialogTimefood ref="DialogTimefood" @submitDialog="submitDialogTimefood" />
    <!-- 发送菜移桌 -->
    <DialogMove ref="DialogMove" @submitDialog="submitDialogMove" />
    <!-- 取餐时间 -->
    <DialogTimePicker ref="DialogTimePicker" @submitDialog="submitDialogTimePicker" />
    <!-- 备注 -->
    <DialogRemark ref="DialogRemark" @submitDialog="submitOrderRemark" />
    <!-- 追单 -->
    <DialogReminder ref="DialogReminder" @submit="dialogReminderSubmit" />

  </div>
</template>

<script>
import mixin_print from '@/mixins/mixin_print'
import mixin_pay from '@/mixins/mixin_pay'
import DialogPay from './components/DialogPay'
import DialogError from '@/components/DialogError'
import DialogCusfood from './components/DialogCusfood'
import DialogTimefood from './components/DialogTimefood'
import DialogCombo from './components/DialogCombo'
import DialogSpec from './components/DialogSpec'
import DialogMove from './components/DialogMove'
import DialogTimePicker from './components/DialogTimePicker'
import DialogRemark from './components/DialogRemark'
import DialogReminder from './components/DialogReminder'
export default {
  name: 'menus',
  mixins: [mixin_print, mixin_pay],
  components: {
    DialogPay,
    DialogError,
    DialogCusfood,
    DialogTimefood,
    DialogCombo,
    DialogSpec,
    DialogMove,
    DialogTimePicker,
    DialogRemark,
    DialogReminder,
  },
  data() {
    return {
      type: 'fastfood', // takeaways normal fastfood
      typeIndex: 1,
      step: '1',
      takeawayForm: {
        name: '',
        phone: '',
        time: '',
      },
      takeawayInfo: [
        { key: 'name', editable: false },
        { key: 'phone', editable: false },
      ],

      categorys: [],
      categoryIndex: 0,
      categoryKey: '',
      searchKey: '',
      items: [],
      cartItems: [],
      remark: '',
      activeIndex: '',

      currentItem: {},

      submitBtnOk: false, // 规格对话框 右下角 按钮样式

      tableData: {}, // 餐桌
      orderData: {
        fixSceneMenuId: '',
        orderItemDetailList: [],
        serviceFee: 0,
        costOrigin: 0,
        userCost: 0,
        code: '',
        packageFee: 0,
        orderType: 1,
        takeout: false,
      }, // 订单

      selectSceneId: '', // 选择的餐桌化场景ID
      sceneList: [], // 餐桌化场景列表

      currentItem_incart: {}, // 修改规格 购物车商品
      hasSendCookIds: [],
      newSendCookIds: [],


      item_del_id: '',

      isShowTangshiBtn: false, // 是否显示堂食按钮
      isShowTakeawayBtn: false, // 是否显示外卖按钮

      childOrderData: {},

      stockErrorFoods: [], // 余量不足

      customTakeaway: {},

      timer_timeHandler: null,
      clearPaymentTimer: null,
    }
  },
  computed: {
    sceneId_here() {
      if (this.shop_x.sceneAsMenu) {
        if (this.$route.query.mid) {
          return Number(this.$route.query.mid)
        } else if (this.orderData && this.orderData.fixSceneMenuId) {
          return this.orderData.fixSceneMenuId
        }
      }
      return this.sceneId_x
    },
  },
  filters: {
  },
  watch: {
    sceneId_x(nval, oval) {
      if (this.shop_x.sceneAsMenu) {

      } else if (nval && this.currentRoute === 'menu') {
        // 第一次赋值会清空订单数据
        // 由父组件调用
        // this.resetData()
        this.init_afterSceneChange(oval ? true : false)
      }
    },
  },
  methods: {
    // 仅限外卖使用
    navToClacAndOpenDialog(key) {
      let { id } = this.orderData
      this.$router.push(`calcway?oid=${id}&sid=${this.currentShopId}&open=${key}`)
    },

    // #region 场景餐桌化
    // 选择餐桌化场景
    async sceneChange(e) {
      if (this.orderData && this.orderData.id) {
        const _R = await this.setData('order', {
          shopId: this.currentShopId,
          id: this.orderData.id,
          fixSceneMenuId: e,
        })
      }

      this.$router.replace({ query: {
        ...this.$route.query,
        mid: e
      } })

      this.judgeCart()
      
      // #region 请求新的餐桌化场景绑定的菜单
      // 获取 分类
      const _R_catalog = await this.getData('catalog', {
        shopId: this.currentShopId,
        filterSceneId: this.sceneId_here,
        sortField: ['showOrder'],
        sortType: 'ASC',
        filterOnlineItem: true,
        filterSoldOutItem: true, // 库存显示参数
      })
      // console.log(`%c分类:`, 'color: #00f;', _R_catalog)
      let arr = []
      arr = await this.sendAjax_category('hot')
      arr.length && _R_catalog.unshift({key: 'hot', id: '0'})
      this.categorys = _R_catalog

      // 获取 商品
      this.changeCategory(this.categorys[0], 0)
      // #endregion
    },
    // #endregion

    // #region 勾选处理
    // localStorageCheckedItemsGet(orderId) {
    //   let DOLA_CHECKED_ORDER_ITEMS = JSON.parse(localStorage.getItem('dola_orderCheckedItems')) || []
    //   const ITEM_CURRENT = DOLA_CHECKED_ORDER_ITEMS.find(x => x.id === orderId)
    //   if (ITEM_CURRENT) {
    //     return ITEM_CURRENT.items
    //   } else {
    //     return false
    //   }
    // },
    // localStorageCheckedItemsSet(orderId, items) {
    //   let DOLA_CHECKED_ORDER_ITEMS = JSON.parse(localStorage.getItem('dola_orderCheckedItems')) || []
    //   const ITEM_CURRENT = DOLA_CHECKED_ORDER_ITEMS.find(x => x.id === orderId)
    //   if (ITEM_CURRENT) {
    //     ITEM_CURRENT.items = items
    //   } else {
    //     DOLA_CHECKED_ORDER_ITEMS.push({
    //       id: orderId,
    //       items
    //     })
    //     if (DOLA_CHECKED_ORDER_ITEMS.length > 50) {
    //       DOLA_CHECKED_ORDER_ITEMS = DOLA_CHECKED_ORDER_ITEMS.slice(-50)
    //     }
    //   }
    //   localStorage.setItem('dola_orderCheckedItems', JSON.stringify(DOLA_CHECKED_ORDER_ITEMS))
    // },
    // #endregion


    // #region 取餐时间 2022-12-26 11:35:16
    openDialogTime() {
      const { time } = this.takeawayForm
      const T = new Date()
      const hour = T.getHours()
      const min = T.getMinutes()
      const n1 = hour < 10 ? '0' + hour : hour
      const n2 = min < 10 ? '0' + min : min
      const value = time && time.includes(':') ? time : (n1 + ':' + n2)
      this.$refs.DialogTimePicker.open(value)
    },
    submitDialogTimePicker(time) {
      this.takeawayForm.time = time
      if (this.orderData.id) {
        const { id, remarks } = this.orderData
        const { name, phone, time } = this.takeawayForm
        this.setData('order', {
          shopId: this.currentShopId,
          id,
          remarks,
          userName: name,
          contact: phone,
          takeOutPickupDate: time,
        })
      }
    },
    // #endregion

    // 外卖模式下，提交电话
    submitTel() {
      // let { name, phone } = this.takeawayForm
      // if (phone) {
      //   this.step = '2'
      // }
      this.step = '2'
    },
    // 快餐模式下，切换堂食或外卖
    async typeIndexChange(index) {
      if (this.typeIndex !== index) {
        if (this.orderData.id) {
          let orderType = ['',4,2][index]
          const _R = await this.setData('order', {
            shopId: this.currentShopId,
            id: this.orderData.id,
            orderItemDetailList: this.orderData.orderItemDetailList,
            orderType,
          })
          // console.log(`%c切换后的订单:`, 'color: #f00;', _R)
          if (_R) {
            this.typeIndex = index
            this.handleRetrunData(_R)
          }
        } else {
          this.typeIndex = index
        }
      }
    },

    // #region 菜单区域
    // 切换菜单
    async changeCategory(item, index) {
      if (!this.currentShopId) {
        return
      }
      this.categoryIndex = index
      if (item) {
        this.categoryKey = item.key
        this.items = await this.sendAjax_category(item.key, item.id)
        this.items_ori = JSON.parse(JSON.stringify(this.items))
      } else {
        this.categoryKey = ''
        this.items = []
        this.items_ori = []
      }
    },
    async sendAjax_category(key, id) {
      let _R = []
      if (key) {
        switch (key) {
          case 'hot':
            _R = await this.getData('item', {
              shopId: this.currentShopId,
              filterSceneId: this.sceneId_here,
              queryRealTimePrice: true,
              querryAtLeastCharge: true,
              suggestion: true,
              suggestionOnline: true,
              filterSuggestion: true,
              online: true,
              pageSize: 999,
              sortField: ['suggestShowOrder'],
              sortType: 'ASC',
              filterSoldOutItem: true, // 库存显示参数
            })
            break
        }
      } else if (id) {
        _R = await this.getData('catalog2item', {
          shopId: this.currentShopId,
          filterSceneId: this.sceneId_here,
          // querryAtLeastCharge: true,
          catalogId: id || '',
          online: true,
          pageSize: 999,
          // sortField: ['showOrder'],
          // sortType: 'ASC',
          filterSoldOutItem: true, // 库存显示参数
        })
      }
      // console.log(123, _R)
      // this.items = _R
      return _R
    },
    // 搜索商品
    // async searchItem() {
    //   // const _R = await this.getData('item', {
    //   //   shopId: this.currentShopId,
    //   //   filterSceneId: this.sceneId_here,
    //   //   queryRealTimePrice: true,
    //   //   querryAtLeastCharge: true,
    //   //   online: true,
    //   //   name: this.searchKey,
    //   // })
    //   // // console.log(`%c商品:`, 'color: #f00;', _R)
    //   // this.items = _R

    //   if (this.searchKey) {
    //     // console.log(this.items)
    //     this.items = this.items.filter(x1 => {
    //       if (x1['name' + this._lang] && x1['name' + this._lang].includes(this.searchKey)) {
    //         return x1
    //       } else if (x1['itemName' + this._lang] && x1['itemName' + this._lang].includes(this.searchKey)) {
    //         return x1
    //       }
    //     })
    //   } else {
    //     this.items = JSON.parse(JSON.stringify(this.items_ori))
    //   }
    // },

    // #region 点击菜单里的菜品
    async tapMenuItem(item) {
      if (!item.saleOut) {
        // 外卖情况下，如果不点确认直接点菜，可以自动点确认
        if (['takeaways','fastfood','custom'].includes(this.type) && this.step === '1') {
          this.step = '2'
        }

        this.currentItem_incart = {}
        // if (this.categoryKey === 'hot') {
        //   this.tapItemCallback(item)
        // } else {
        //   const _R = await this.getData('item', {
        //     id: item.itemId,
        //     filterSceneId: this.sceneId_here,
        //     queryRealTimePrice: true,
        //     querryAtLeastCharge: true,
        //   })
        //   if (_R.length) {
        //     let item2 = _R[0]
        //     this.tapItemCallback(item2)
        //   }
        // }
        const rD = {
          // id: item.itemId,
          filterSceneId: this.sceneId_here,
          queryRealTimePrice: true,
          querryAtLeastCharge: true,
        }
        if (this.categoryKey === 'hot') {
          rD.id = item.id
        } else {
          rD.id = item.itemId
        }
        const _R = await this.getData('item', rD)
        if (_R.length) {
          this.tapItemCallback(_R[0])
        }
      }
    },
    tapItemCallback(item) {
      console.log(`%c点击的商品详情:`, 'color: #00f;', item)
      if (item.setMenu) {
        // 套餐
        this.$refs.DialogCombo.tapCombo(item)
      } else if (item.itemDetailList.length) {
        // 规格
        this.$refs.DialogSpec.tapSpec(item)
      } else if (item.realPriceItem) {
        // 时价菜 一般菜品
        // console.log('时价菜')
        this.currentItem = item
        this.addCartBefore(() => {
          // this.$refs.DialogTimefood.open(this.orderData.costOrigin)
          this.$refs.DialogTimefood.open(item['name' + this._lang])
        })
      } else {
        // 一般菜品
        // console.log(`%c无规格-商品详情:`, 'color: #00f;', item)

        // #region 验证价格大于最低消费
        // minimumOrderingCharge
        // showMinimumOrderingCharge
        // querryAtLeastCharge

        // 加入菜品时用item的showMinimumOrderingCharge
        // 修改菜品时用order.orderItemDetailList的minimumOrderingCharge
        if (this.showMinCostLimitedWarning({
          price: item.price,
          min: item.showMinimumOrderingCharge
        })) { return }
        // #endregion

        this.currentItem = item
        this.addCartBefore(() => {
          this.addCarting(1)
        })
      }
    },
    // #endregion

    // #region 时价菜
    async submitDialogTimefood(val) {
      // console.log(val.price)

      // #region 验证价格大于最低消费
      // minimumOrderingCharge
      // showMinimumOrderingCharge
      // querryAtLeastCharge

      // 加入菜品时用item的showMinimumOrderingCharge
      // 修改菜品时用order.orderItemDetailList的minimumOrderingCharge
      if (this.showMinCostLimitedWarning({
        price: Number(val.price),
        min: this.currentItem.showMinimumOrderingCharge
      })) { return }
      // #endregion
      
      if (this.currentItem_incart.id) {
        if (!this.hasSendCookIds.includes(this.currentItem_incart.id) || this.user_x.privilegeList.includes('sjzhgl_bdksxgcp')) {
          // 没有发送过
          this.refreshCartItemTimefood(val)
        } else {
          // 发送过 打开二级密码验证
          this.$refs.DialogKey.open({
            orderId: this.orderData.id,
            sceneType: 5,
            onConfirm: async () => {
              this.refreshCartItemTimefood(val)
            }
          })
        }
      } else {
        this.addCartBefore(() => {
          this.submitDialogTimefood_then(val)
        })
      }
    },
    async submitDialogTimefood_then(val) {
      if (val.price !== '') {
        let rD = {
          shopId: this.currentShopId,
          id: this.orderData.id,
          orderItemDetailList: [{
            itemId: this.currentItem.id,
            count: 1,
            sceneId: this.sceneId_here,
            itemPrice: Number(val.price),
            minimumOrderingCharge: this.currentItem.showMinimumOrderingCharge
          }]
        }
        const { id, setMenu, itemDetailList } = this.currentItem
        if (setMenu) {
          // 套餐
          // console.log(`%c当前弹框套餐:`, 'color: #00f;', this.currentItem)
          let setMenuOneItemList = this.comboSubmitHandle(this.currentItem)
          rD.orderItemDetailList[0].setMenuOneItemList = setMenuOneItemList
        } else if (itemDetailList.length) {
          // 规格
          const itemDetailList = this.specSubmitHandle(this.currentItem)
          // console.log(`%c选择的规格:`, 'color: #00f;', itemDetailList)
          if (itemDetailList) {
            rD.orderItemDetailList[0].itemDetailList = itemDetailList
          } else { return }
        } else {
          // 一般菜品
        }
        
        // 如果开启了延时打印（出现勾选框），先判断有无缓存过，没有则先缓存[]
        // if (this.shopConfig_m.printerDelay) {
        //   const RESULT = this.localStorageCheckedItemsGet(this.orderData.id)
        //   RESULT === false && this.localStorageCheckedItemsSet(this.orderData.id, [])
        // }
        // 发送购物车变动请求
        let _D = await this.sendAjax_changeCartItem(rD)
        if (_D === 'ok') {
          this.$refs.DialogCombo.close()
          this.$refs.DialogSpec.close()
          // 变动之后勾选上最后一个加入的商品
          // this.shopConfig_m.printerDelay && this.checkItemCook(this.cartItems[this.cartItems.length - 1])
          this._scrollToBottom('.scrolly') // 滚动
        }
      }
    },
    // 更新菜品提交
    async refreshCartItemTimefood(val) {
      if (val.price !== '') {
        let rD = {
          shopId: this.currentShopId,
          id: this.orderData.id,
          orderItemDetailList: [{
            ...this.currentItem_incart,
            // id: this.currentItem_incart.id,
            // itemId: this.currentItem_incart.itemId,
            sceneId: this.sceneId_here,
            itemPrice: Number(val.price),
            updatePrice: true,
            updateItemAndSendKitchen: this.isSendFlag,
          }]
        }
        delete rD.orderItemDetailList[0].count
        const { id, setMenu, itemDetailList } = this.currentItem
        if (setMenu) {
          // 套餐
          let setMenuOneItemList = this.comboSubmitHandle(this.currentItem)
          rD.orderItemDetailList[0].setMenuOneItemList = setMenuOneItemList
        } else if (itemDetailList.length) {
          // 规格
          const itemDetailList = this.specSubmitHandle(this.currentItem)
          // console.log(`%c选择的规格:`, 'color: #00f;', itemDetailList)
          if (itemDetailList) {
            rD.orderItemDetailList[0].itemDetailList = itemDetailList
          } else { return }
        } else {
          // 一般菜品
        }
        // console.log(`%crD:`, 'color: #00f;', rD)
        let _D = await this.sendAjax_changeCartItem(rD)
        if (_D === 'ok') {
          this.$refs.DialogCombo.close()
          this.$refs.DialogSpec.close()
        }
      }
    },
    // #endregion

    // #endregion

    // 检查是否最低价
    showMinCostLimitedWarning({ price = 0, min = 0 } = obj) {
      if (price < min) {
        this.$message.warning(this.$t('item.minCostLimited1') + min + this.$t('item.minCostLimited2'))
        return true
      } else {
        return false
      }
    },

    // #region 套餐or规格菜对话框 提交
    dialogComboOrSpecSubmit(result, isSendFlag = false) {
      // console.log(`%cresult:`, 'color: #00f;', result)

      this.isSendFlag = isSendFlag

      this.currentItem = result
      if (result.realPriceItem) {
        this.currentItem_incart.id ? this.$refs.DialogTimefood.open(result['name' + this._lang]) : this.addCartBefore(() => {
          // this.$refs.DialogTimefood.open(this.orderData.costOrigin)
          this.$refs.DialogTimefood.open(result['name' + this._lang])
        })
      } else {

        // #region 验证价格大于最低消费
        // minimumOrderingCharge
        // showMinimumOrderingCharge
        // querryAtLeastCharge

        // 加入菜品时用item的showMinimumOrderingCharge
        // 修改菜品时用order.orderItemDetailList的minimumOrderingCharge
        if (this.showMinCostLimitedWarning({
          price: Number(result._price),
          min: result.showMinimumOrderingCharge
        })) { return }
        // #endregion
        
     
        // console.log(this.currentItem_incart.id, this.hasSendCookIds, this.user_x.privilegeList.includes('sjzhgl_bdksxgcp'))
        if (this.currentItem_incart.id) {
          if (!this.hasSendCookIds.includes(this.currentItem_incart.id) || this.user_x.privilegeList.includes('sjzhgl_bdksxgcp')) {
            // 没有发送过
            this.refreshCartItem()
          } else {
            // 发送过 打开二级密码验证
            this.$refs.DialogKey.open({
              orderId: this.orderData.id,
              sceneType: 5,
              onConfirm: async () => {
                this.refreshCartItem()
              }
            })
          }
        } else {
          this.addCartBefore(() => {
            this.addCarting(1)
          })
        }
      }
    },
    // 更新菜品提交
    async refreshCartItem() {
      let rD = {
        shopId: this.currentShopId,
        id: this.orderData.id,
        orderItemDetailList: [{
          ...this.currentItem_incart,
          // id: this.currentItem_incart.id,
          // itemId: this.currentItem_incart.itemId,
          sceneId: this.sceneId_here,
          updateItemAndSendKitchen: this.isSendFlag,
        }]
      }
      delete rD.orderItemDetailList[0].count
      const { id, setMenu, itemDetailList } = this.currentItem
      if (setMenu) {
        // 套餐
        let setMenuOneItemList = this.comboSubmitHandle(this.currentItem)
        rD.orderItemDetailList[0].setMenuOneItemList = setMenuOneItemList
      } else if (itemDetailList.length) {
        // 规格
        const itemDetailList = this.specSubmitHandle(this.currentItem)
        // console.log(`%c选择的规格:`, 'color: #00f;', itemDetailList)
        if (itemDetailList) {
          rD.orderItemDetailList[0].itemDetailList = itemDetailList
        }
      } else {
        // 一般菜品
      }
      // console.log(`%crD:`, 'color: #00f;', rD)
      // return
      let _D = await this.sendAjax_changeCartItem(rD)
      if (_D === 'ok') {
        this.$refs.DialogCombo.close()
        this.$refs.DialogSpec.close()
      }
    },
    // #endregion

    // #region 加入购物车
    // 加入购物车前 判断是否存在订单對象
    async addCartBefore(callback) {
      // console.log(`%c123123c:`, 'color: #00f;', this.type, this.typeIndex)
      if (!this.orderData.id) {
        this.type === 'normal' && await this.judgeCart() // 堂食時 查询订单是否剛生成

        if (!this.orderData.id) {
          const { name, phone, time } = this.takeawayForm
          const rD = {
            shopId: this.currentShopId,
            sceneId: this.sceneId_here,
            userName: name,
            contact: phone,
            takeOutPickupDate: time,
          }
          // if (this.shop_x.sceneAsMenu) {
          //   rD.fixSceneMenuId = this.selectSceneId
          // }
          if (this.type === 'fastfood' && this.typeIndex === 1) {
            rD.orderType = 4
          } else if (this.type === 'takeaways' && this.typeIndex === 1) {
            rD.orderType = 2
          } else if (this.type === 'custom') {
            rD.orderType = 2
            rD.takeoutSettingId = Number(this.$route.query.payId)
          // } else if (['takeaways','fastfood','custom'].includes(this.type) && this.typeIndex === 2) {
          } else if (this.typeIndex === 2) {
            // rD.orderType = 2
          } else if (this.type === 'normal') {
            delete rD.userName
            delete rD.contact
            delete rD.takeOutPickupDate
            // rD.orderType = 1
            rD.tableRow = this.tableData.row
            rD.tableColumn = this.tableData.column
            rD.uniqueCode = this.tableData.uniqueCode
          }

          const _R = await this.newData('order', rD)
          this.handleRetrunData(_R)
          this.tableData.orderId = _R.id
          callback()
        } else {
          callback()
        }

      } else {
        callback()
      }
    },
    // 加入购物车
    async addCarting(count) {
      const { id, setMenu, itemDetailList } = this.currentItem
      let rD = {
        shopId: this.currentShopId,
        id: this.orderData.id,
        orderItemDetailList: [
          { itemId: id, count, sceneId: this.sceneId_here, minimumOrderingCharge: this.currentItem.showMinimumOrderingCharge }
        ]
      }
      if (setMenu) {
        // 如果是套餐
        let setMenuOneItemList = this.comboSubmitHandle(this.currentItem)
        rD.orderItemDetailList[0].setMenuOneItemList = setMenuOneItemList
      } else if (itemDetailList.length) {
        // 如果有规格
        const itemDetailList = this.specSubmitHandle(this.currentItem)
        if (!itemDetailList) { return }
        rD.orderItemDetailList[0].itemDetailList = itemDetailList
      }

      // 如果开启了延时打印（出现勾选框），先判断有无缓存过，没有则先缓存[]
      // if (this.shopConfig_m.printerDelay) {
      //   const RESULT = this.localStorageCheckedItemsGet(this.orderData.id)
      //   RESULT === false && this.localStorageCheckedItemsSet(this.orderData.id, [])
      // }
      // 发送购物车变动请求
      console.log(`%crD:`, 'color: #00f;', rD)
      let _D = await this.sendAjax_changeCartItem(rD)
      if (_D === 'ok') {
        this.$refs.DialogCombo.close()
        this.$refs.DialogSpec.close()
        // 变动之后勾选上最后一个加入的商品
        // this.shopConfig_m.printerDelay && this.checkItemCook(this.cartItems[this.cartItems.length - 1])
        this._scrollToBottom('.scrolly') // 滚动
      }
    },
    // #endregion

    // #region 数据格式处理函数
    specSubmitHandle(spec) {
      let itemDetailList = [], nameAndPriceList = []
      spec.itemDetailList.forEach(x1 => {
        x1.nameAndPriceList.forEach(x2 => {
          x2.select && nameAndPriceList.push(x2)
        })
        if (nameAndPriceList.length) {
          let itemDetail = JSON.parse(JSON.stringify(x1))
          itemDetail.nameAndPriceList = nameAndPriceList
          itemDetailList.push(itemDetail)
        }
        nameAndPriceList = []
      })
      return itemDetailList
    },
    comboSubmitHandle(combo) {
      let setMenuOneItemList = JSON.parse(JSON.stringify(combo.setMenuOneItemList))
      setMenuOneItemList.forEach(x1 => {
        if (x1.fixed) {
          x1.itemList.forEach(x2 => {
            x2.countInOrder = 1
            let list3 = []
            if (x2.itemDetailList) {
              // 有规格
              x2.itemDetailList.forEach(x3 => {
                let list4 = []
                x3.nameAndPriceList.forEach(x4 => {
                  x4.select && list4.push(x4)
                })
                if (list4.length) {
                  x3.nameAndPriceList = list4
                  list3.push(x3)
                }
              })
              x2.itemDetailList = list3
            } else {
              // 无规格
            }
          })
        } else {
          // const FOOD_SELECTED = x1.itemList.find(x => x.select)
          // if (FOOD_SELECTED.id) {
          //   // 是菜品
          //   if (FOOD_SELECTED.itemDetailList) {
          //     // 有规格
          //     let list3 = []
          //     FOOD_SELECTED.itemDetailList.forEach(x3 => {
          //       let list4 = []
          //       x3.nameAndPriceList.forEach(x4 => {
          //         x4.select && list4.push(x4)
          //       })
          //       if (list4.length) {
          //         x3.nameAndPriceList = list4
          //         list3.push(x3)
          //       }
          //     })
          //     FOOD_SELECTED.itemDetailList = list3
          //     x1.itemList = [FOOD_SELECTED]
          //   } else {
          //     // 无规格
          //     x1.itemList = [FOOD_SELECTED]
          //   }
          // } else {
          //   // 是不加配
          //   x1.itemList = [FOOD_SELECTED]
          // }
          const FOOD_SELECTED_LIST = x1.itemList.filter(x => x.select)
          // console.log(111, FOOD_SELECTED_LIST)
          const itemList = []
          FOOD_SELECTED_LIST.forEach(x2 => {
            x2.countInOrder = x2.checkedNum
            if (x2.id) { // 是菜品
              if (x2.itemDetailList && x2.itemDetailList.length) { // 有规格
                x2.countInOrder = 1
                let list3 = []
                x2.itemDetailList.forEach(x3 => {
                  let list4 = []
                  x3.nameAndPriceList.forEach(x4 => {
                    x4.select && list4.push(x4)
                  })
                  if (list4.length) {
                    x3.nameAndPriceList = list4
                    list3.push(x3)
                  }
                })
                x2.itemDetailList = list3
              }
            }
            itemList.push(x2)
          })
          x1.itemList = itemList
        }
      })
      // console.log(`%c处理后的setMenuOneItemList:`, 'color: #00f;', setMenuOneItemList)
      return setMenuOneItemList
    },
    // #endregion

    // #region 购物车菜品区域
    // 点击购物车的商品，改变规格
    async tapCartItem(item) {
      console.log(`%c点击的购物车item:`, 'color: #00f;', item)
      this.currentItem_incart = item

      if (item.itemId === -100) {
        // console.log(`%c是特殊菜:`, 'color: #00f;', item)
      } else {
        const _Rs = await this.getData('item', {
          shopId: this.currentShopId,
          id: item.itemId,
        })
        let _R = _Rs[0]
        console.log(`%c点击的购物车item对应的商品:`, 'color: #f00;', _R)
        _R.price = item.basePrice // 这里查询出来的菜品没有基础价，因为要以加入购物车时的场景判断，所以这里读取购物车上保存的基础价
        _R.showMinimumOrderingCharge = item.minimumOrderingCharge // 这里查询出来的菜品没有基础价，因为要以加入购物车时的场景判断，所以这里读取购物车上保存的基础价
        item.showMinimumOrderingCharge = item.minimumOrderingCharge // 这里查询出来的菜品没有基础价，因为要以加入购物车时的场景判断，所以这里读取购物车上保存的基础价
        
        if (_R.setMenu) {
          // 如果是套餐
          this.$refs.DialogCombo.comboCartModify(item, _R, this.hasSendCookIds.includes(item.id))
        } else if (_R.itemDetailList.length) {
          // 如果有规格
          this.$refs.DialogSpec.specCartModify(item, _R, this.hasSendCookIds.includes(item.id))
        } else if (_R.realPriceItem) {
          // 时价菜 一般菜品
          console.log('时价菜')
          this.currentItem = item
          this.$refs.DialogTimefood.open(item['name' + this._lang])
        }
      }
    },

    // 勾选菜品 准备发送厨房
    async checkItemCook(item) {
      // 先判断是否已经存在于发送过的菜品列表，存在则不能勾选
      // 再判断是否已经勾选，已选则取消勾选
      // if (!this.hasSendCookIds.includes(item.id)) {
      //   this.newSendCookIds.includes(item.id)
      //     ? this.newSendCookIds.splice(this.newSendCookIds.findIndex(x => x === item.id), 1)
      //     : this.newSendCookIds.push(item.id)

      //   this.localStorageCheckedItemsSet(this.orderData.id, this.newSendCookIds)
      // }
      if (!this.hasSendCookIds.includes(item.id)) {
        let item_ = JSON.parse(JSON.stringify(item))
        item_.sceneId = this.sceneId_here
        item_.canSendToKitchen = !item.canSendToKitchen
        delete item_.count

        let rD = {
          shopId: this.currentShopId,
          id: this.orderData.id,
          orderItemDetailList: [
            item_
          ],
        }
        // console.log(`%crD:`, 'color: #00f;', rD)
        this.sendAjax_changeCartItem(rD)
      }
    },
    // 展开隐藏
    changeOpenItem(index) {
      // this.activeIndex = this.activeIndex === index ? '' : index
      if (this.activeIndex === index) {
        this.activeIndex = ''
      } else {
        this.activeIndex = index
        const REFS = this.$refs['item' + index]
        if (REFS && REFS.length) {
          // console.log(111, REFS[0])
          let timer = setTimeout(() => {
            // https://www.jianshu.com/p/8b44deeee6eb
            // https://blog.csdn.net/weixin_45622540/article/details/105531888
            // REFS[0].scrollIntoView()
            // REFS[0].scrollIntoView(false)
            REFS[0].scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'})
            clearTimeout(timer)
          }, 300)
        }
      }
    },
    tapSubtract(item) {
      // console.log(`%citem:`, 'color: #00f;', item)
      this.currentItem_incart = item
      if (item.count > 1) {
        // console.log(this.hasSendCookIds.includes(item.id))
        if (this.hasSendCookIds.includes(item.id) && !this.user_x.privilegeList.includes('sjzhgl_bdkssccp')) {
          // 如果已经发送了，需要二级密码
          // console.log(this.currentItem_incart)
          this.$refs.DialogKey.open({
            orderId: this.orderData.id,
            sceneType: 2,
            onConfirm: () => {
              let rD = {
                shopId: this.currentShopId,
                id: this.orderData.id,
                orderItemDetailList: [
                  { id: this.currentItem_incart.id, count: -1, sceneId: this.sceneId_here }
                ]
              }
              this.sendAjax_changeCartItem(rD)
            }
          })
        } else {
          this.changeItemCount(item, -1)
        }
      } else {
        this.delItem(item)
      }
    },
    // 增減数量
    changeItemCount(item, count) {
      if (!this.hasSendCookIds.includes(item.id) || (count < 1 && this.user_x.privilegeList.includes('sjzhgl_bdkssccp'))) {
        let { id } = item
        let rD = {
          shopId: this.currentShopId,
          id: this.orderData.id,
          orderItemDetailList: [
            { id, count, sceneId: this.sceneId_here }
          ]
        }
        // console.log(`%crD:`, 'color: #00f;', rD)
        this.sendAjax_changeCartItem(rD)
      }
    },
    // 标注为外卖
    markItemType(item) {
      if (!this.hasSendCookIds.includes(item.id)) {
        item.takeout = !item.takeout
        let item_ = JSON.parse(JSON.stringify(item))
        item_.sceneId = this.sceneId_here
        delete item_.count
        let rD = {
          shopId: this.currentShopId,
          id: this.orderData.id,
          orderItemDetailList: [
            item_
          ],
        }
        // console.log(`%crD:`, 'color: #00f;', rD)
        this.sendAjax_changeCartItem(rD)
      }
    },
    delItem(item) {
      this.item_del_id = item.id
      // 如果已经发送了，需要二级密码
      if (this.hasSendCookIds.includes(item.id) && !this.user_x.privilegeList.includes('sjzhgl_bdkssccp')) {
        this.$refs.DialogKey.open({
          orderId: this.orderData.id,
          sceneType: 2,
          onConfirm: this.sendAjax_delItem
        })
      } else {
        this.sendAjax_delItem()
      }
    },
    // 发送上传购物车商品的Ajax请求
    async sendAjax_delItem() {
      let rD = {
        shopId: this.currentShopId,
        id: this.orderData.id,
        orderItemDetailList: [
          { id: this.item_del_id, sceneId: this.sceneId_here, delete: true }
        ],
      }
      // console.log(`%crD:`, 'color: #00f;', rD)
      let _D = await this.sendAjax_changeCartItem(rD)
      if (_D === 'ok') {
        this.activeIndex = ''
      }
    },

    // 追单
    async reminderItem(item) {
      console.log(`%c点击的追单item:`, 'color: #00f;', item)
      this.currentItem_incart = item

      if (item.setMenu) {
        // 如果是套餐
        this.$refs.DialogReminder.open(item)
      } else {
        // 普通菜+时价菜+特殊菜+规格菜
        const rD = {
          shopId: this.currentShopId,
          printerId: this.printerId_x,
          id: this.orderData.id,
          orderItemDetailList: [{
            id: this.currentItem_incart.id,
            count: this.currentItem_incart.count,
            itemDetailList: this.currentItem_incart.itemDetailList,
          }]
        }
        this.$api.reminder_kitchen(rD).then(async res => {
          if (res.status == 0) {
            this.$message.success(this.$t('menu.reminderSentSuccess'))
            this.$refs.DialogReminder.close()
          } else { this._status(res) }
        })
      }
    },
    dialogReminderSubmit(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      const setMenuOneItemList = []
      result.forEach(x2 => {
        const ITEM = setMenuOneItemList.find(x1 => x1.id === x2.pid)
        // console.log(`%cITEM:`, 'color: #f00;', ITEM)
        if (ITEM) {
          ITEM.itemList.push(x2)
        } else {
          setMenuOneItemList.push({
            id: x2.pid,
            countInOrder: x2.countInOrder,
            itemList: [x2]
          })
        }
      })
      const rD = {
        shopId: this.currentShopId,
        printerId: this.printerId_x,
        id: this.orderData.id,
        orderItemDetailList: [{
          id: this.currentItem_incart.id,
          count: this.currentItem_incart.count,
          setMenuOneItemList
        }]
      }
      console.log(`%crD:`, 'color: #00f;', rD)

      this.$api.reminder_kitchen(rD).then(async res => {
        if (res.status == 0) {
          this.$message.success(this.$t('menu.reminderSentSuccess'))
          this.$refs.DialogReminder.close()
        } else { this._status(res) }
      })
    },
    // 移位
    moveTable(item) {
      this.$refs.DialogMove.open(this.orderData, item)
    },
    // 移位
    async submitDialogMove() {
      this.activeIndex = ''
      await this.judgeCart()
      if (this.orderData && this.orderData.orderItemDetailList && this.orderData.orderItemDetailList.length === 0) {
        this.NavToPrePageThen()
      }
    },

    // #endregion

    // #region 购物车下方面板
    // 給订单添加包裝费
    async addOrderPackageFee(n) {
      // console.log(1123, this.orderData.packageFee + n >= 0 && this.orderData.id)
      if (this.orderData.packageFee + n >= 0 && this.orderData.id) {
        this.orderData.packageFee += n
        
        // let { packageFee, orderItemDetailList } = this.orderData
        let { packageFee } = this.orderData
        const _R = await this.setData('order', {
          shopId: this.currentShopId,
          id: this.orderData.id,
          packageFee,
          // orderItemDetailList,
        })
        // console.log(`%c设置包装费后的订单:`, 'color: #f00;', _R)
        this.orderData.userCost = _R.userCost
      }
    },
    // 給订单添加姓名 电话
    addOrderInfo(item) {
      // @focus="onFocus_forScan" @blur="onBlur_forScan"
      // this.scan_canLeave_x_save(true)
      this.onBlur_forScan()
      item.editable = false
      if (this.orderData.id) {
        const { id, remarks } = this.orderData
        const { name, phone, time } = this.takeawayForm
        this.setData('order', {
          shopId: this.currentShopId,
          id,
          remarks,
          userName: name,
          contact: phone,
          takeOutPickupDate: time,
        })
      }
    },
    // 点击对话框中发送厨房按钮，发送账单到厨房
    sendCookClick() {
      const printerDelay = this.shopConfig_m.printerDelay
      // 如果开启了延时打印，并且有勾选菜品 || 如果未开启延时打印，直接全部打印
      if ((printerDelay && this.newSendCookIds.length) || !printerDelay) {
        let rD = {
          shopId: this.currentShopId,
          id: this.orderData.id,
          sendPrinterList: [],
          printerId: this.printerId_x,
        }
        // 餐桌模式点击打印就返回餐桌页面 || 快餐模式点击打印就刷新页面
        const CALLBACK = () => {
          this.resetData()
          this.NavToPrePage2()
        }
        // 如果开启了延时打印，并且有勾选菜品 || 如果未开启延时打印，直接全部打印
        if (printerDelay && this.newSendCookIds.length) {
          this.newSendCookIds.forEach(x => {
            rD.sendPrinterList.push({ orderItemId: x })
          })
          this.sendCookCallback(rD, CALLBACK)
        } else if (!printerDelay) {
          this.cartItems.forEach(x => {
            rD.sendPrinterList.push({ orderItemId: x.id })
          })
          this.sendCookCallback(rD, CALLBACK)
        }
      }
    },
    async sendCookCallback(rD, callback) {
      const _R = await this.sendAjax_sendCook_mixin(rD)
      if (_R) {
        this.handleRetrunData(_R)
        this.activeIndex = ''
        this.newSendCookIds = []
        // this.shopConfig_m.printerDelay && this.localStorageCheckedItemsSet(this.orderData.id, [])

        callback && callback()
      }
    },
    // 打印小票
    printOrderClick() {
      if (this.printerId_x) {
        this.$api.print_order({
          shopId: this.currentShopId,
          id: this.orderData.id
        }, this.printerId_x).then(res => {
          if (res.status == 0) {
          } else { this._status(res) }
        })
      } else { this.$message.warning(this.$t('print.printerError')) }
    },
    calcClick() {
      let rD = {
        shopId: this.currentShopId,
        id: this.orderData.id,
      }
      this.$api.order_calc_before(rD).then(async res => {
        if (res.status == 0) {
          let _R = res.data
          if (_R.length) {
            // console.log(`%c_R:`, 'color: #f00;', _R)
            this.stockErrorFoods = _R.map(x => {
              if (x.saleOut) {
                return {
                  text_zh: x.item.name_zh + ' 已售罄',
                  text_en: x.item.name_en + ' is sold out',
                }
              } else {
                return {
                  text_zh: x.item.name_zh + ' 可点数量' + x.availableCount + '份',
                  text_en: x.item.name_en + ' remains ' + x.availableCount + (x.availableCount === 1 ? ' order' : ' orders'),
                }
              }
            })
            this.stockErrorFoods.push({
              text_zh: '请修改数量！',
              text_en: 'please change the quantity !',
            })
            this.$refs.DialogError.open()
          } else {
            switch (this.type) {
              case 'normal':
                this.navtoCalcPage()
                break;
              case 'custom':
              case 'editcustom':
                // this.navtoCalcPage()
                console.log(`%ccustomTakeaway:`, 'color: #00f;', this.customTakeaway)
                const { enablePayType, payTypeId } = this.customTakeaway
                if (enablePayType && payTypeId) {
                  this.el_loading_x_save(true)
                  const id = await this.createChildOrder()
                  if (id) {
                    this.$api.payment_pay({
                      shopId: this.currentShopId,
                      id,
                      payType: this.orderData.takeoutBindPayType,
                      printerId: this.printerId_x,
                    }).then(res => {
                      if (res.status == 0) {
                        // console.log(`%cres.data:`, 'color: #f00;', res.data)
                        this.judgeCart() // 刷新订单
                        this.sendPayCallback && this.sendPayCallback(id) // 分菜页面用
                        this.NavToPrePage()
                      } else { this._status(res) }
                    })
                  }
                  this.el_loading_x_save(false)
                } else {
                  this.createPayment()
                }
                break;
              default:
                this.createPayment()
                break;
            }
          }
        } else { this._status(res) }
      })
    },
    // #endregion

    // #region 自定义菜
    // 添加自定义菜品 打开对话框
    openDialogCusfood() {
      this.$refs.DialogCusfood.open(this.orderData.costOrigin)
    },
    // 添加自定义菜品 添加对话框
    async submitDialogCusfood(val) {
      this.addCartBefore(() => {
        this.submitDialogCusfood_then(val)
      })
    },
    async submitDialogCusfood_then(val) {
      if (val.price !== '') {
        // console.log(`%cval:`, 'color: #00f;', val)
        const item = {
          itemId: -100,
          count: 1,
          itemPrice: Number(val.price),
          itemName: val.name,
          // itemName_zh: val.name_zh,
          // itemName_en: val.name_en,
          // printLabel: val.label,
          sceneId: this.sceneId_here
        }

        // #region 点击按钮时需要传国际化
        if (val.fixed) {
          item.itemName_zh = val.name_zh
          item.itemName_en = val.name_en
        // } else {
        //   item.itemName = val.name
        }
        // #endregion

        val.label && (item.printLabel = val.label)
        const rD = {
          shopId: this.currentShopId,
          id: this.orderData.id,
          orderItemDetailList: [
            item
          ],
        }
        // 如果开启了延时打印（出现勾选框），先判断有无缓存过，没有则先缓存[]
        // if (this.shopConfig_m.printerDelay) {
        //   const RESULT = this.localStorageCheckedItemsGet(this.orderData.id)
        //   RESULT === false && this.localStorageCheckedItemsSet(this.orderData.id, [])
        // }
        // 发送购物车变动请求
        let _D = await this.sendAjax_changeCartItem(rD)
        if (_D === 'ok') {
          // 变动之后勾选上最后一个加入的商品
          // this.shopConfig_m.printerDelay && this.checkItemCook(this.cartItems[this.cartItems.length - 1])
          this._scrollToBottom('.scrolly') // 滚动
        }
      }
    },
    // #endregion

    // #region 备注
    openDialogOrderRemark(type, item) {
      if (type === 'order') {
        if (this.orderData.id) {
          this.$refs.DialogRemark.open({
            type,
            // list: this.orderData.remarksTemplateList,
            // content: this.orderData.remarks
            obj: this.orderData
          })
        }
      } else if (type === 'item') {
        if (!this.hasSendCookIds.includes(item.id)) {
          this.$refs.DialogRemark.open({
            type,
            // list: item.remarksTemplateList,
            // content: item.remarks
            obj: item
          })
        }
      }
    },
    async submitOrderRemark(val) {
      const { type, list, content, obj: item } = val
      // console.log(`%cval:`, 'color: #f0f;', list, content)
      if (type === 'order') {
        const _R = await this.setData('order', {
          shopId: this.currentShopId,
          id: this.orderData.id,
          remarksTemplateList: list,
          remarks: content,
        })
        if (_R) {
          this.handleRetrunData(_R)
          this.$refs.DialogRemark.close()
        }
      } else if (type === 'item') {
        let item_ = JSON.parse(JSON.stringify(item))
        item_.sceneId = this.sceneId_here
        item_.addRemarks = true
        item_.remarksTemplateList = list
        item_.remarks = content
        delete item_.count

        let rD = {
          shopId: this.currentShopId,
          id: this.orderData.id,
          orderItemDetailList: [
            item_
          ],
        }
        let _D = await this.sendAjax_changeCartItem(rD)
        if (_D === 'ok') {
          this.$refs.DialogRemark.close()
        }
      }
    },
    // #endregion


    // 发送变动购物车商品的Ajax请求
    sendAjax_changeCartItem(rD) {
      return this.$api.cart_add(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          // console.log(`%c_R:`, 'color: #f00;', _R)
          if (Object.prototype.toString.call(_R) === '[object Array]') {
            this.stockErrorFoods = _R.map(x => {
              if (x.saleOut) {
                return {
                  text_zh: x.item.name_zh + ' 已售罄',
                  text_en: x.item.name_en + ' is sold out',
                }
              } else {
                return {
                  text_zh: x.item.name_zh + ' 可点数量' + x.availableCount + '份',
                  text_en: x.item.name_en + ' remains ' + x.availableCount + (x.availableCount === 1 ? ' order' : ' orders'),
                }
              }
            })
            this.stockErrorFoods.push({
              text_zh: '请修改数量！',
              text_en: 'please change the quantity !',
            })
            this.$refs.DialogError.open()
            return false
          } else if (Object.prototype.toString.call(_R) === '[object Object]') {
            this.handleRetrunData(_R)
            return 'ok'
          }
        } else { this._status(res) }
      })
    },
    // 處理返回的订单數據
    handleRetrunData(data) {
      this.orderData = data
      // data.orderItemDetailList.push(this.currentItem1)
      this.cartItems = data.orderItemDetailList
      console.log(`%c返回的订单+id+状态:`, 'color: #f00;', data.id, data.status, data)
      
      const { userName, contact, takeOutPickupDate } = data
      const time = takeOutPickupDate === '-1' ? this.$t('menu.now') : takeOutPickupDate
      this.takeawayForm = {
        name: userName,
        phone: contact,
        time,
      }

      // #region 判断订单是否是外卖订单
      if (data.orderType == 2) {
        data.takeout = true
      }
      // #endregion

      // #region 判断订单是否含有标记为外卖的菜品
      for (let i1 = 0; i1 < data.orderItemDetailList.length; i1++) {
        const x1 = data.orderItemDetailList[i1];
        if (x1.takeout) {
          data.takeout = true
          break
        }
      }
      // #endregion

      if (data.status === 100) {
        // this.resetData()
      } else {
        this.hasSendCookIds = []
        data.sendPrinterList.forEach(x => {
          this.hasSendCookIds.push(x.orderItemId)
        })
        data.hasSendCookIds = this.hasSendCookIds

        if (this.shopConfig_m.printerDelay) {
        //   const RESULT = this.localStorageCheckedItemsGet(data.id)
        //   if (RESULT) {
        //     this.newSendCookIds = RESULT
        //   } else {
        //     let { orderItemDetailList, hasSendCookIds } = data, items = []
        //     orderItemDetailList.forEach(x => {
        //       if (!hasSendCookIds.includes(x.id)) {
        //         items.push(x.id)
        //       }
        //     })
        //     this.newSendCookIds = items
        //   }
        //   // console.log(`%cthis.newSendCookIds:`, 'color: #00f;', this.newSendCookIds)

          let { orderItemDetailList, hasSendCookIds } = data, items = []
          orderItemDetailList.forEach(x => {
            if (!hasSendCookIds.includes(x.id) && x.canSendToKitchen) {
              items.push(x.id)
            }
          })
          this.newSendCookIds = items
        }

        this.isShowTimeOfPlaceOrders && this.timeHandler(data)
      }
    },


    // 餐桌堂食模式下，点击结算，跳转到结算页面
    async navtoCalcPage() {
      this.autoPrint_mixin(this.orderData.id, this.cartItems, this.hasSendCookIds, () => {
        let { status, id } = this.orderData
        switch (status) {
          case 4: case 7: case 9:
            this.$router.push(`/calcwayFood?oid=${id}&sid=${this.currentShopId}`)
            break
          case 5: case 8:
            this.$router.push(`/calcwayAvg?oid=${id}&sid=${this.currentShopId}`)
            break
          case 6: case 10:
            this.$router.push(`/calcwayCus?oid=${id}&sid=${this.currentShopId}`)
            break
          default:
            this.$router.push(`calcway?oid=${id}&sid=${this.currentShopId}`)
            break
        }
      })
    },
    // 快餐模式和外卖模式下，点击结算，打开支付对话框
    createPayment() {
      this.autoPrint_mixin(this.orderData.id, this.cartItems, this.hasSendCookIds, () => {
        this.$refs.DialogPay.open({
          cash: this.orderData.userCost,
          poid: this.orderData.id
        })
      })
    },
    // 创建支付订单
    createChildOrder(eftPay) {
      let rD = {
        shopId: this.currentShopId,
        orderId: this.orderData.id,
      }
      eftPay && (rD.eftPay = true)

      // rD.customerId = this.customer.customerId
      return this.$api.payment_create(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          // console.log(`%c新建的订单:`, 'color: #00f;', _R)
          this.childOrderData = _R
          return _R.id
        } else { this._status(res) }
      })
    },
    // 支付对话框 关闭支付结果
    NavToPrePage() {
      this.$message.success(this.$t('pay.finPay'))
      this.clearPaymentTimer = setTimeout(() => {
        this.NavToPrePageThen()
        clearTimeout(this.clearPaymentTimer)
      }, 2000)
    },
    NavToPrePageThen() {
      if (this.homePage_x === 'table') {
        switch (this.fromPage) {
          case 'table': this.$router.go(-1); break
          case 'orderDetail':
          case null: 
            let { type, oid } = this.$route.query
            if (['edit', 'editcustom'].includes(type)) {
              this.$router.replace(`/orderDetail?oid=${oid}`)
            } else {
              this.$router.replace('table')
            }
            break
          default: this.$router.replace('table'); break
        }
      } else if (this.homePage_x === 'menu') {
        switch (this.fromPage) {
          case 'menu': this.$router.go(-1); break
          case 'orderDetail':
          case null: 
            let { type, oid } = this.$route.query
            if (['edit', 'editcustom'].includes(type)) {
              this.$router.replace(`/orderDetail?oid=${oid}`)
            } else {
              this.$router.replace('menu?type=fastfood')
            }
            break
          default: this.$router.replace('menu?type=fastfood'); break
        }
      }
    },
    NavToPrePage2() {
      console.log(`%cthis.homePage_x:`, 'color: #00f;', this.homePage_x)
      if (this.homePage_x === 'table') {
        switch (this.fromPage) {
          case 'table': this.$router.go(-1); break
          case 'orderDetail':
          case null: 
            let { type, oid } = this.$route.query
            if (['edit', 'editcustom'].includes(type)) {
              this.$router.replace(`/orderDetail?oid=${oid}`)
            } else {
              this.$router.replace('table')
            }
            break
          default: this.$router.replace('table'); break
        }
      } else if (this.homePage_x === 'menu') {
        switch (this.fromPage) {
          case 'menu': this.$router.go(-1); break
          default: 
            this.type = 'fastfood'
            this.$router.replace('menu?type=fastfood')
            break
        }
      }
    },

    // #region 获取
    // 获取 自定义外卖平台
    async getCustomTakeaway() {
      const _R = await this.getData('customTakeaway', {
        shopId: this.currentShopId,
        id: this.$route.query.payId
      })
      console.log(`%c自定义外卖平台:`, 'color: #f00;', _R)
      this.customTakeaway = _R[0]
    },
    isShowTakeaway() {
      // console.log(`%c已保存的模式列表:`, 'color: #f0f;', this.modelList_x)
      const ITEM_MODEL_Tangshi = this.modelList_x.find(x => x.type === 2)
      this.isShowTangshiBtn = !!ITEM_MODEL_Tangshi && ITEM_MODEL_Tangshi.enable
      const ITEM_MODEL_Takeaway = this.modelList_x.find(x => x.type === 5)
      this.isShowTakeawayBtn = !!ITEM_MODEL_Takeaway && ITEM_MODEL_Takeaway.enable
      if (!ITEM_MODEL_Tangshi && !!ITEM_MODEL_Takeaway && ITEM_MODEL_Takeaway.enable) {
        // console.log(123)
        this.typeIndex = 2
      }
    },
    // 判断购物车是否已经存在
    async judgeCart() {
      let { row, column, uniqueCode, orderId } = this.tableData
      let rD = {
        shopId: this.currentShopId,
        filterCheckoutOrderItem: true,
      }
      if (orderId) {
        rD.id = orderId
      } else {
        rD.foodTableKey = `${row}:${column}:${uniqueCode}`
      }
      const _Rs = await this.getData('order', rD)
      
      if (_Rs.length) {
        // console.log(`%c订单:`, 'color: #00f;', _Rs[0])
        if (_Rs[0].status !== 100) {
          this.handleRetrunData(_Rs[0])
        } else {
          this.resetData()
        }
      } else {
        this.resetData()
      }
    },
    // 获取数据
    async init_afterSceneChange(isShowAll) {
      // console.log(`%cvuex的场景id:`, 'color: #f00;', this.sceneId_here)
      if (this.sceneId_here) {

        if (['custom','editcustom'].includes(this.type)){
          this.getCustomTakeaway()
        }

        // 获取 分类
        const _R_catalog = await this.getData('catalog', {
          shopId: this.currentShopId,
          filterSceneId: this.sceneId_here,
          sortField: ['showOrder'],
          sortType: 'ASC',
          filterOnlineItem: true,
          filterSoldOutItem: true, // 库存显示参数
          switchSceneAction: isShowAll,
        })
        // console.log(`%c分类:`, 'color: #00f;', _R_catalog)
        let arr = []
        arr = await this.sendAjax_category('hot')
        arr.length && _R_catalog.unshift({key: 'hot', id: '0'})
        this.categorys = _R_catalog
  
        // 如果是快餐模式，需要判断是否需要显示外卖按钮
        this.isShowTakeaway()

        // 获取 商品
        this.changeCategory(this.categorys[0], 0)
  
        // console.log(`%ctype:`, 'color: #f00;', this.type)

        // #region 场景餐桌化
        if (this.shop_x.sceneAsMenu) {
          const _R_scene = this.scene_x.filter(x1 => x1.sceneAsMenu)
          console.log(`%c餐桌化场景:`, 'color: #f00;', _R_scene)
          this.sceneList = _R_scene.map(x1 => {
            return {
              id: x1.id,
              name: x1.name,
            }
          })

          if (this.$route.query.mid) {
            this.selectSceneId = Number(this.$route.query.mid)
          } else if (this.orderData && this.orderData.fixSceneMenuId) {
            this.selectSceneId = this.orderData.fixSceneMenuId
          }
        }
        // #endregion
      }

      // console.log(`%c123123c:`, 'color: #00f;', this.type, this.typeIndex)
    },
    // #endregion

    // 重置data
    resetData() {
      // console.log(`%c重置data`, 'color: #f00;')
      this.orderData = {
        orderItemDetailList: [],
        serviceFee: 0,
        costOrigin: 0,
        userCost: 0,
        code: '',
        packageFee: 0,
        orderType: 1,
        takeout: false,
      }
      this.takeawayForm = {
        name: '',
        phone: '',
        time: '',
      }
      this.step = '1'
      // this.typeIndex = 1
      this.cartItems = []
      this.hasSendCookIds = []
      this.newSendCookIds = []
      this.childOrderData = {}
    },

    // #region 处理发送厨房的时间标志
    timeHandler(data) {
      // console.log(`%c11111`, 'color: #f00;',)
      data.orderItemDetailList.forEach(x1 => {
        // x1.sendToKitchenTime = 1665457788339
        let CURRENT_TIME = new Date().getTime()
        if (x1.payedTime && x1.payedTime < CURRENT_TIME) {
          CURRENT_TIME = x1.payedTime
        }
        if (this.hasSendCookIds.includes(x1.id) && x1.sendToKitchenTime) {
          let t = Math.floor((CURRENT_TIME - x1.sendToKitchenTime) / 1000 / 60)
          if (t > 999) t = '>999'
          if (t < 0) t = '0'
          this.$set(x1, 'sendToKitchenTimeText_zh', t + '分鐘')
          this.$set(x1, 'sendToKitchenTimeText_en', t + ' Min')
        } else {
          this.$set(x1, 'sendToKitchenTimeText_zh', '')
          this.$set(x1, 'sendToKitchenTimeText_en', '')
        }
      })
    },
    // #endregion
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.fromPage = from.name

      let { type, c, r, uid, oid } = (to.query || vm.$route.query)
      vm.type = type || 'fastfood'

      vm.step = '1'
      vm.tableData = {
        row: Number(r),
        column: Number(c),
        uniqueCode: Number(uid),
        orderId: Number(oid),
      }
      if (['normal', 'edit', 'editcustom'].includes(type)) {
        await vm.judgeCart()
      } else {
        await vm.resetData()
      }

      vm.init_afterSceneChange(false)

      if (vm.isShowTimeOfPlaceOrders) {
        vm.timer_timeHandler = setInterval(() => {
          vm.orderData && vm.orderData.id && vm.timeHandler(vm.orderData)
        }, 1000)
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    if (this.categoryIndex !== 0) {
      this.changeCategory(this.categorys[0], 0)
    }
    this.takeawayForm = {
      name: '',
      phone: '',
      time: '',
    }
    this.activeIndex = ''
    clearInterval(this.timer_timeHandler)
    clearInterval(this.clearPaymentTimer)
    next()
  },
}
</script>

<style lang='scss' scoped>
.section-right{overflow: hidden;}
.section-dialog{
  width: 360px;background: #fff;padding-top: 2px;box-sizing: border-box;
  .dialog-head{
    height: 60px;position: relative;
    .dialog-head-btn{text-align: center;line-height: 56px;border: 2px solid #374978;box-sizing: border-box;}
    .select-box{
      position: absolute;right: 20px;
      /deep/ .el-input__inner{background: transparent;color: #fff;}
      /deep/ .el-select .el-input.is-focus .el-input__inner,
      /deep/ .el-select .el-input__inner:focus{border-color: #dcdfe6;}
    }
  }
  // 默认
  .dialog-con{
    box-sizing: border-box;overflow: hidden scroll;height: calc(100% - 60px);padding: 0 20px;
    .item{
      // height: 64px;
      min-height: 64px;
      box-sizing: border-box;transition: all .3s;overflow: hidden;position: relative;
      &:last-child{border-bottom: none;}
  
      .item-infos{padding-right: 24px;}
      .item-counter{height: 56px;position: absolute;right: 0;top: 0px;}

      .item-info{line-height: 24px;}
      .item-info.item-info-price-box{
        padding-right: 50px;
        span.time{text-align: center;background: #000;color: #fff;border-radius: 4px;padding: 2px 8px;}
      }
      .item-btn{width: 24px;height: 24px;border-radius: 50%;}
      .item-number{padding: 0 8px;}
      .more-btn{width: 10px;height: 7px;padding: 8px 7px;transition: all .3s;}
      .item-show{padding: 8px 0;min-height: 48px;}
      .item-hide{transition: all .3s;}
      .hang{padding-bottom: 10px;}
      .input{width: 180px;height: 26px;line-height: 26px;}
      .reminder-btn{min-width: 70px;margin-right: 20px;}
      .move-btn{width: 70px;min-width: 70px;padding: 0;margin-right: 20px;}
      .delete-btn{width: 70px;height: 30px;line-height: 30px;text-align: center;background: #000;color: #fff;font-size: 16px;border-radius: 4px;}
      .checkbox{margin-right: 10px;margin-top: 3px;}
    }
    
    .remark-input{width: 200px;height: 26px;line-height: 26px;}
    .scrolly{min-height: 80px;}
    .dialog-con-btm{
      overflow: hidden;
      .texts{padding: 12px 0;}
      .dialog-btm{padding: 20px 0;}
      .dialog-btm .btn{height: 40px;line-height: 40px;width: 100px;min-width: 100px;}
    }
    // 发送ed
    .item-ban{
      .item-show{
        .item-infos{color: #666;}
        .item-counter{color: #666;}
      }
      .item-hide{
        .hang{color: #666;}
        .input{color: #666;border-color: #666;}
        ::placeholder{color: #666;}
      }
    }
  }
  // 堂食
  .normal1{
    .dialog-top{
      height: 60px;box-sizing: border-box;
      .dialog-num{height: 60px;}
    }
    .dialog-ctr{
      overflow: hidden scroll;
      .texts{padding: 12px 0;}
    }
  }
  // 外卖 1
  .takeaways1,
  .fastfood1,
  .custom1{
    .dialog-input{
      height: 200px;box-sizing: border-box;padding: 15px 0;
      .dialog-input-item{height: 30px;line-height: 30px;}
      .dialog-input-input{width: 160px;height: 30px;line-height: 30px;}
    }
    .dialog-btn{margin: 80px auto;}
  }
  // 外卖 2
  .takeaways2,
  .fastfood2,
  .custom2,
  .editcustom1,
  .edit1{
    .dialog-con-top{
      height: 110px;box-sizing: border-box;padding: 15px 0;
      .dialog-input-item{height: 30px;line-height: 30px;}
      .dialog-input-input{width: 160px;height: 30px;line-height: 30px}
    }
  }
}
.section-navs{
  background: #fff;padding: 20px;margin-bottom: 20px;
  // overflow: scroll hidden;
  .nav{padding: 0 20px;width: auto;white-space: nowrap;height: 48px;line-height: 48px;}
  .nav.active{font-weight: bold;}
}
.section-con{
  padding-left: 20px;overflow: hidden scroll;
  .section-search{
    position: relative;width: 230px;
    .input {
      background: transparent;
      width: 230px;height: 34px;line-height: 34px;padding: 0 50px 0 10px;box-sizing: border-box;
      border: 2px solid #374978;border-radius: 2px;font-size: 14px;color: #666;
      &::placeholder{color: #666;}
    }
    .iconmagnifier{width:20px;height:20px;position: absolute;top: 0;bottom: 0;margin: auto;right: 10px;}
  }
  .section-items{
    height: calc(100% - 54px);align-content: flex-start;
    overflow: hidden scroll;margin-top: 20px;
    .item{width: calc(100% / 6 - 10px);background: #fff;margin: 0 10px 20px 0;position: relative;}
    .name{height: 50px;color: #555;text-align: center;padding: 0 4px; box-sizing: border-box;}
    .name span{line-height: 22px;}
    .hide::after{
      content: attr(data-hide);display: inline-block;width: 100%;height: 100%;
      background: rgba($color: #000000, $alpha: 0.5);color: #fff;font-size: 20px;
      position: absolute;top: 0;left: 0;display: flex;justify-content: center;align-items: center;
    }
    .item.item-noimg{
      height: 80px;line-height: 80px;border: 1px solid #374978;border-radius: 4px;box-sizing: border-box;
      display: flex;justify-content: center;align-items: center;
      .name{color:#374978;}
    }
  }
}
</style>